import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { timetableSlotActions as slice } from "../slices/timetableSlot";
import { getErrorMessage } from "../../utils/errorUtils";
import { TimetableSlotResponseDto } from "../../shared/dtos/timetableSlot/TimetableSlotResponseDto";
import { UpdateTimetableSlotPayload } from "../../shared/interfaces/timetableSlot/UpdateTimetableSlotPayload";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export interface TimetableSlotQueryParams {
  branchId?: string;
  timetableId?: string;
  teacherId?: string;
  subjectId?: string;
  dayOfWeek?: string;
}

export const getTimetableSlots =
  (params?: TimetableSlotQueryParams) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingTimetableSlots());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<TimetableSlotResponseDto[]>
      >("/timetable-slots", {
        headers: { requiresAuth: true },
        params,
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(slice.setTimetableSlots(data.data));
      }
    } catch (error) {
      dispatch(slice.setErrorLoadingTimetableSlots(getErrorMessage(error)));
    }
  };

export const getTimetableSlotById =
  (id: string) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingTimetableSlot());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<TimetableSlotResponseDto>
      >(`/timetable-slots/${id}`, { headers: { requiresAuth: true } });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(slice.setTimetableSlot(data.data));
      }
    } catch (error) {
      dispatch(slice.setErrorLoadingTimetableSlot(getErrorMessage(error)));
    }
  };

export const updateTimetableSlot =
  (payload: UpdateTimetableSlotPayload) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingTimetableSlotUpdate());
    try {
      const { data } = await axiosInstance.put<
        ApiResponseDto<TimetableSlotResponseDto>
      >(`/timetable-slots/${payload.id}`, payload.values, {
        headers: { requiresAuth: true },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Timetable slot updated successfully!");
        dispatch(slice.updateTimetableSlotSuccess(data.data));
        dispatch(
          slice.setServerResponseStatus({
            operation: "update",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(slice.setErrorUpdatingTimetableSlot(message));
    }
  };

export const resetTimetableSlotServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(slice.setServerResponseStatus(null));
};
